import FeedFetcher from "../components/Feed.fetcher";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useEffect } from "react";
import { Box } from "@radix-ui/themes";

export default function FeedPage() {
  // Page Document Title
  useDocumentTitle("Feed");

  const navigate = useNavigate();

  useEffect(() => {
    if (!brand.hasFeature.posts) {
      return navigate(siteRoutes["home"]);
    }
  }, [brand]);

  return (
    <Box>
      <FeedFetcher />
    </Box>
  );
}
